export default {
  assetDetails: {},
  tokenRequest: {},
  searchResult: [],
  recentRaising: [],
  companiesRaising: [],
  companiesRaised: [],
  tokens: [],
  token: {},
  orderBook: null,
  buyOrderBook: null,
  sellOrderBook: null,
  totalOrder: null,
  companyUpdate: [],
  singleTokenBalance: 0,
  companyUpdatePage: 0,
  companyUpdatePages: 0,
  orderPage: 0,
  orderPages: 0,
  tokenPage: 0,
  tokenPages: 0,
  raisedPage: 0,
  raisedPages: 0,
  raisingPage: 0,
  raisingPages: 0,
};
